module.exports = __webpack_public_path__ + "img/img_preparo_concluido.c9b270d1.svg";